<template>
  
    <div class="light-box" v-if="!closed">
      <div class="light-wrapper" ref="wrapper">
        <swiper :options="leftOptions" class="custom-wrapper left-wrapper" ref="leftSwiper">
          <swiper-slide class="swiper-no-swiping">
           <slot name="left" v-bind:scope="data"></slot>
          </swiper-slide>
        </swiper> 
        <swiper :options='rightOptions' class="custom-wrapper right-wrapper"  ref="rightSwiper">
          <swiper-slide v-for="(url,index) in data.zpic" :key="index">
            <div class="swiper-slide-box">
              <template v-if="isVideo(url)">
                <video :src="url" controls></video>
              </template>
              <template v-else>
              <img :src="resources[url].src" class="light-box-pic"/>
              </template>
            </div>
           
          </swiper-slide>
          <template v-if="data.zpic.length>1">
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          </template>
          
        </swiper>
      </div>
      <slot name="close"></slot>
    </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
const SWIPEROPTIONS = {

}
export default {
  name: 'LightBox',
  componentName:'LightBox',
  components:{
    swiper,
    swiperSlide
  },
  data(){
    return {
      leftOptions:{},
      rightOptions:{},
      resources:[]
    }
  },
  created(){
    this.resources = this.$store.state.resources;

  },
  mounted(){
    let self = this;
    this.leftOptions = {
      ...SWIPEROPTIONS,
      effect:'fade',
      fadeEffect: {
        crossFade: true
      },
      noSwiping : true
    };
    this.rightOptions = {
      ...SWIPEROPTIONS,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChangeTransitionStart(){
          self.pauseVideo();
        }
      }
    };
  },
  beforeDestroy(){
    this.pauseVideo();
  },
  methods:{
    isVideo(url){
      return url.indexOf('mp4')>=0;
    },
    pauseVideo(){
      var wrapper  = this.$refs.wrapper ;
      if(wrapper) {
        let videos = wrapper.querySelectorAll("video") ;
        for(var i = 0 ,len = videos.length ; i < len ;i ++){
          var v = videos[i];
          v.pause();
        }
      }
    }
  },
  props:{
    closed:{
      type:Boolean,
      default: true
    },
    data: {
      type:Object,
      required:true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../common/common.scss";
.light-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: rgba(0,0,0,.85);
    z-index: 1200;
    color: #fff;
    .light-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: px2rem(1642);
      height: px2rem(855);
      display: flex;
      align-items: stretch;
      overflow: hidden;
    }
    .left-wrapper {
      width: px2rem(316);
    }
    .right-wrapper {
      flex:1;
      // background: #fff;
      color: #fff;
      margin-left: px2rem(46);
      font-size: 14px;
      position: relative;
    }
  }

  /deep/ .swiper-button-prev {
    left: 0;
    right: auto;
  }
  .swiper-slide-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .light-box-pic {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    display: block;
    margin: auto;
    object-fit:contain;
  }
  video {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  .swiper-slide-box {
    width: 100%;
    height: 100%;
    position: relative;
    background: url("../assets/loading.svg") center center no-repeat;
    background-size: 100px;
  }
</style>
